export type PmcNetworkSite = {
  name: string;
  url: string;
};

/**
 * PMC / PMX network properties shown in the Footer "Our Sites" dropdown.
 * Order and URLs come from the stakeholder brand list. Update this file
 * independently of the renderer.
 */
export const PMC_NETWORK_SITES: readonly PmcNetworkSite[] = [
  { name: "The American Pavilion", url: "https://www.ampav.com/" },
  { name: "ARTnews", url: "https://www.artnews.com/" },
  {
    name: "Art in America",
    url: "https://www.artnews.com/c/art-in-america/",
  },
  { name: "Artforum", url: "https://www.artforum.com/" },
  { name: "Art Week NYC", url: "https://art-week.com/" },
  { name: "Beauty Inc", url: "https://wwd.com/beauty-industry-news/" },
  { name: "Billboard", url: "https://www.billboard.com/" },
  { name: "Deadline", url: "https://deadline.com/" },
  { name: "Dick Clark Productions", url: "https://www.dickclark.com/" },
  { name: "The Dodo", url: "https://www.thedodo.com/" },
  { name: "Eater", url: "https://www.eater.com/" },
  { name: "Flow Space", url: "https://www.theflowspace.com/" },
  { name: "FN", url: "https://wwd.com/footwear-news/" },
  { name: "Gold Derby", url: "https://www.goldderby.com/" },
  { name: "Golden Globes", url: "https://goldenglobes.com/" },
  { name: "The Hollywood Reporter", url: "https://www.hollywoodreporter.com/" },
  { name: "IndieWire", url: "https://www.indiewire.com/" },
  { name: "Life is Beautiful", url: "https://www.lifeisbeautiful.com/" },
  { name: "Popsugar", url: "https://www.popsugar.com/" },
  { name: "Punch", url: "https://punchdrink.com/" },
  { name: "SJ Denim", url: "https://wwd.com/sourcing-journal/sj-denim/" },
  { name: "Robb Report", url: "https://robbreport.com/" },
  { name: "Rolling Stone", url: "https://www.rollingstone.com/" },
  { name: "SB Nation", url: "https://www.sbnation.com/" },
  { name: "SHE Media", url: "https://www.shemedia.com/" },
  { name: "She Knows", url: "https://www.sheknows.com/" },
  { name: "Sourcing Journal", url: "https://wwd.com/sourcing-journal/" },
  { name: "Soaps", url: "https://soaps.sheknows.com/" },
  { name: "Sportico", url: "https://www.sportico.com/" },
  { name: "StyleCaster", url: "https://stylecaster.com/" },
  { name: "SXSW", url: "https://sxsw.com/" },
  { name: "Thrillist", url: "https://www.thrillist.com/" },
  { name: "Variety", url: "https://variety.com/" },
  { name: "The Verge", url: "https://www.theverge.com/" },
  { name: "Vibe", url: "https://www.vibe.com/" },
  { name: "WWD", url: "https://wwd.com/" },
];
